export type NvpStatus = "online" | "offline" | "unknown";

const STYLES: Record<NvpStatus, string> = {
  online: "bg-green-500",
  offline: "bg-red-500",
  unknown: "bg-gray-200",
};

const LABELS: Record<NvpStatus, string> = {
  online: "Online",
  offline: "Offline",
  unknown: "Unknown",
};

export const STATUS_BORDER_COLORS: Record<NvpStatus, string> = {
  online: "border-l-green-300",
  offline: "border-l-red-300",
  unknown: "border-l-stone-300",
};

interface NvpStatusDotProps {
  status: NvpStatus;
  label?: string;
}

export function NvpStatusDot({ status, label }: NvpStatusDotProps) {
  return (
    <div
      className="flex items-center gap-1.5"
      title={label ? `${label} — ${LABELS[status]}` : LABELS[status]}
    >
      <span className={`inline-block h-2.5 w-2.5 rounded-full ${STYLES[status]}`} />
      {label && (
        <span className="text-sm text-muted-foreground">{label}</span>
      )}
    </div>
  );
}
